export const dateFilterOptions = [
  {
    key: "today",
    label: "Today",
    isDefault: true,
    manipulate: {
      type: "duringInDate",
      add: [0, "day"],
      startOf: "day",
      endOf: "day",
    },
  },
  {
    key: "yesterday",
    label: "Yesterday",
    manipulate: {
      type: "duringInDate",
      add: [-1, "day"],
      startOf: "day",
      endOf: "day",
    },
  },
  {
    key: "last_7_days",
    label: "Last 7 days",
    manipulate: {
      type: "dayToDay",
      addStart: [-6, "day"],
      addEnd: [1, "day"],
    },
  },
  {
    key: "last_30_days",
    label: "Last 30 days",
    manipulate: {
      type: "dayToDay",
      addStart: [-29, "day"],
      addEnd: [1, "day"],
    },
  },
  {
    key: "custom",
    label: "Custom Range",
  },
];
